import React from "react";

export const Loading = (props) => {
  return (
    <div className="uk-text-center">
      <span data-uk-spinner="ratio: 3"></span>
    </div>
  );
};
